module.exports = __webpack_public_path__ + "static/media/banner-2.6bae00cd.jpg";